module.exports = __webpack_public_path__ + "img/img14.140e6c5c.png";